import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { languageSliceInitialState } from "../../types/reduxSlices";

const initialState: languageSliceInitialState = {
  currentLanguage: "",
};

const languageSlice = createSlice({
  name: "languageSlice",
  initialState,
  reducers: {
    handleUpdateCurrentLanguage: (state, action: PayloadAction<string>) => {
      state.currentLanguage = action.payload;
    },
  },
});

export const { handleUpdateCurrentLanguage } = languageSlice.actions;

export default languageSlice.reducer;
